import { render, staticRenderFns } from "./FormulaTagInput.vue?vue&type=template&id=13d894c0&scoped=true"
import script from "./FormulaTagInput.vue?vue&type=script&lang=js"
export * from "./FormulaTagInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d894c0",
  null
  
)

export default component.exports